import {NavLink} from 'react-router-dom';
import {
    Box,
    Breadcrumbs,
} from '@mantine/core';

import {DefectSignature} from '../types';
import config from '../config';

export const DetailPageNavigation = ({component}: { component: DefectSignature }) => {

    const breadcrumbs = [{
        title: 'Home',
        href: '/dashboard',
    }, {
        title: config.titles.plural,
        href: config.basePath,
    }, {
        // The actionCode, not the fingerprint — the id is a sha256 and would be
        // an unreadable breadcrumb.
        title: component.actionCode,
        href: '',
    }].map((item, index) => (
        <Box key={index}>
            {item.href ? <NavLink to={item.href}>{item.title}</NavLink> : item.title}
        </Box>
    ));

    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};
